import * as React from 'react';
import { SVGProps } from 'react';

const IconGitHubSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.008 3c-5.066 0-9.16 4.125-9.16 9.228a9.22 9.22 0 0 0 6.263 8.755c.455.091.622-.2.622-.443 0-.214-.015-.948-.015-1.712-2.548.55-3.08-1.1-3.08-1.1-.409-1.07-1.015-1.344-1.015-1.344-.834-.565.06-.565.06-.565.926.06 1.411.947 1.411.947.819 1.405 2.138 1.008 2.669.764.076-.596.319-1.009.576-1.238-2.032-.214-4.17-1.008-4.17-4.553 0-1.008.364-1.833.94-2.475-.091-.229-.41-1.176.091-2.444 0 0 .774-.245 2.517.947a8.807 8.807 0 0 1 2.29-.306 8.81 8.81 0 0 1 2.29.306c1.745-1.192 2.518-.947 2.518-.947.5 1.268.182 2.215.091 2.444.592.642.94 1.467.94 2.475 0 3.545-2.138 4.324-4.185 4.553.333.29.621.84.621 1.711 0 1.238-.015 2.231-.015 2.536 0 .245.167.535.622.444a9.221 9.221 0 0 0 6.264-8.755C21.168 7.125 17.058 3 12.008 3Z"
    />
  </svg>
);
export default IconGitHubSizeM;
